import { render, staticRenderFns } from "./SportResultsTable.vue?vue&type=template&id=9526ef82&"
import script from "./SportResultsTable.vue?vue&type=script&lang=js&"
export * from "./SportResultsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports